"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.twoFactorReducer = twoFactorReducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _requestStatus = require("../../types/requestStatus");
var _twoFactorPhone = require("../../actions/twoFactorPhone");
var _defaultState = require("./defaultState");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function twoFactorReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaultState.defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _twoFactorPhone.ETwoFactorPhoneActionTypes.SendCodeLoading:
      return applyPhoneState(state, {
        status: _requestStatus.ERequestStatus.Loading,
        error: null
      });
    case _twoFactorPhone.ETwoFactorPhoneActionTypes.SendCodeFailed:
      return applyPhoneState(state, {
        status: _requestStatus.ERequestStatus.Failed,
        error: action.payload
      });
    case _twoFactorPhone.ETwoFactorPhoneActionTypes.SendCodeSucceed:
      return applyPhoneState(state, {
        status: _requestStatus.ERequestStatus.Succeed,
        senderType: action.payload.senderType,
        secondsToRetry: action.payload.secondsToRetry,
        error: null
      });
    case _twoFactorPhone.ETwoFactorPhoneActionTypes.PhoneChanged:
      return applyPhoneState(state, {
        phone: action.payload
      });
    case _twoFactorPhone.ETwoFactorPhoneActionTypes.AutosubmitChanged:
      return applyPhoneState(state, {
        isAutosubmitEnabled: action.payload
      });
  }
  return state;
}
function applyPhoneState(prevState, payload) {
  return _objectSpread(_objectSpread({}, prevState), {}, {
    twoFactor: _objectSpread(_objectSpread({}, prevState.twoFactor), {}, {
      phoneState: _objectSpread(_objectSpread({}, prevState.twoFactor.phoneState), payload)
    })
  });
}